<template>
    <div class="card text-center mt-3" :id="'card' + dChamado.id" :style="{ backgroundColor: dChamado.tipoChamado.cor }"
        :class="{
            'urgencia-card': props.dChamado.tipoChamado.urgencia === true,
            'card-nao-urgencia': props.dChamado.tipoChamado.urgencia === false,
            'card-aberto': props.dChamado.posicao == 'AB',
            'card-nao-aberto': props.dChamado.posicao != 'AB'
        }">
        <div class="card-header d-flex" :id="'subCard' + dChamado.id" :class="{
            'paddingCard': props.dChamado.tipoChamado.urgencia === true,
            'card1': props.dChamado.tipoChamado.urgencia === false
        }">
            <div class="imagem">
                <label class="spnImg">
                    <img :class="'chamado' + dChamado.tipoChamado.id"
                        :src="require(`@/assets/img/iconeTpChamado/${dChamado.tipoChamado.id}-icone.png`)">
                </label>
            </div>
            <label class="spnDesc" id="spnDesc">
                {{ dChamado.tipoChamado.descricao }}
            </label>
        </div>
        <div class="card-body">
            <p class="card-text" id="leitoDesc">
                {{ dChamado.leito.descricao }}
            </p>
            <p class="card-text" id="quartoDesc">
                {{ dChamado.leito.quarto.descricao }}
            </p>
        </div>
        <div class="card-footer">
            <p class="rodape" v-if="dChamado.posicao != 'AB'">Aberto:</p>
            <p class="rodape" id="horaInicio">{{ formatarData(dChamado.data) }} - {{ dChamado.hora }}</p>
        </div>
        <div class="card-footer"
            v-if="((dChamado.hrCancelamento != null && dChamado.dtCancelamento == null) || (dChamado.posicao === 'AD'))">
            <p class="rodape">Cancelado: </p>
            <p class="rodape" id="administrativo">Cancelamento Administrativo</p>
        </div>
        <div class="card-footer" v-if="(dChamado.hrFinalizacao != null) && (dChamado.posicao !== 'AD')">
            <p class="rodape">Finalizado: </p>
            <p class="rodape" id="tempoFinalizado">{{ formatarData(dChamado.dtFinalizacao) }} - {{ dChamado.hrFinalizacao }}
            </p>
        </div>
        <div class="card-footer"
            v-else-if="(dChamado.hrCancelamento != null && dChamado.dtCancelamento != null) && (dChamado.posicao !== 'AD')">
            <p class="rodape">Cancelado: </p>
            <p class="rodape" id="tempoCancelado">{{ formatarData(dChamado.dtCancelamento) }} - {{ dChamado.hrCancelamento
            }}
            </p>
        </div>
        <div class="card-footer d-flex justify-content-center" v-if="dChamado.posicao != 'AB' && dChamado.posicao != 'AD'">
            <CronometroCard id="tempoCronometro" :dChamado="dChamado" :semTexto="false" />
        </div>
        <div class="card-footer d-flex justify-content-center" v-else-if="dChamado.posicao == 'AD'">
            <CronometroCard id="tempoCronometro" :dChamado="dChamado" :semTexto="false" />
        </div>
        <div class="card-footer d-flex justify-content-center" v-if="temporizadorLigado && dChamado.posicao == 'AB'">
            <CronometroCard id="tempoCronometro" :dChamado="dChamado" :semTexto="false" />
        </div>
    </div>
</template>

<script setup>
import store from '@/store/store';
import moment from 'moment';
import CronometroCard from '@/components/CronometroCard.vue';
import { computed, defineProps } from 'vue';

const props = defineProps(['dChamado', 'tpChamado']);

function formatarData(pData) {
    // return moment(pData).format("DD MMMM YYYY,");
    return moment(pData).format("DD/MM/YYYY");
}

// const config = computed(() => {
//     return store.state.config;
// });

const temporizadorLigado = computed(() => {
    return (store.state.config.cronometro) ? true : false;
});

</script>

<style scoped>
.card {
    width: auto;
    min-width: 300px;
    font-family: sans-serif;
}

.spnDesc {
    width: 100%;
    font-size: 2rem;
    text-align: center;
}

.spnImg {
    width: 100%;
    font-size: 2rem;
    text-align: center;
}

.card-aberto {
    max-height: 275px !important;
}

.card-nao-aberto {
    max-height: 360px !important;
}

.card-text,
.card-title,
.card-header,
.rodape {
    font-weight: bold;
    font-size: 1.3em;
    margin: 0;
}

.card-header {
    background-color: rgba(100, 100, 100, 0.2);
}

.card-body,
.card-footer {
    background-color: rgba(255, 255, 255, 0.2);
}

.card-header {
    text-align: left;
    color: rgba(50, 50, 50, 0.75);
}

.card-body .card-text {
    text-align: left;
}

.card-footer .rodape {
    font-size: 0.9rem;
    text-transform: none;
}

.urgencia-card {
    box-shadow: 0px 7px 16px rgba(82, 9, 11, 0.4) !important;
}

.card {
    box-shadow: 0px 10px 14px rgba(9, 82, 43, 0.2);
}

.urgencia-card .card-text,
.urgencia-card .p,
.urgencia-card .rodape,
.urgencia-card .card-header {
    color: #FFF;
}

.urgencia-card .card-header {
    text-transform: uppercase;
    font-size: 2rem;
}

.card-body {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
}

.card-nao-urgencia .card-footer,
.card-nao-urgencia .card-body {
    background-color: #FFF !important;
}

.card-nao-urgencia {
    border-color: #FFF !important;
}

.rodape {
    font-weight: lighter;
}

.card1 {
    padding-bottom: 1rem;
}

.chamado1 {
    width: calc(var(--tamanho) * 3 * 1.6);
    height: calc(var(--tamanho) * 3.4);
}

.chamado9 {
    width: calc(var(--tamanho) * 3 * 1.6);
    height: calc(var(--tamanho) * 3.4);
}

.chamado2 {
    width: calc(var(--tamanho) * 3.4);
    height: calc(var(--tamanho) * 3.4);
}

.chamado3 {
    width: calc(var(--tamanho) * 4.8);
    height: calc(var(--tamanho) * 3.6);
}

.card-header {
    min-height: 97.33px;
}

.spnDesc {
    align-self: center;
}

.imagem {
    align-self: center;
}

.rodapeCronometro {
    color: #FFF;
}

@media only screen and (max-width : 616px) {
    .card {
        width: auto;
        min-width: 300px;
        min-height: 225px;
        font-family: sans-serif;
    }
}
</style>